import "moment/locale/pt";
import { useIntl } from "react-intl";
// @material-ui/core components
import Box from "@material-ui/core/Box";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
//import custom components
import componentStylesForms from "assets/theme/components/forms.js";
import componentStyles from "assets/theme/views/admin/applications.js";
import GenericButton from "components/Buttons/GenericButton";
import { labels } from "resources/resources";

const useStylesForms = makeStyles(componentStylesForms);
const useStyles = makeStyles(componentStyles);

export default function SubmitedDocumentsSection(props) {
  const classes = { ...useStyles(), ...useStylesForms() };
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down("sm"));
  const intl = useIntl();

  return (
    <>
      {props.files?.map((file, key) => (
        <Box
          key={key}
          style={
            isSmDown
              ? { paddingRight: 0, marginBottom: theme.spacing(2) }
              : { paddingRight: "20px" }
          }
        >
          <Box className={classes.detailLabels}>{file.documentType}</Box>

          <Box className={classes.documentNameRoot}>{file.name}</Box>
          <Box>
            <GenericButton
              typeSubmit={false}
              key={key}
              onClick={() => {
                props.getDocument(file.documentId, file.documentName);
              }}
              color="tertiary"
              size={isSmDown ? "medium" : undefined}
              fullWidth={isSmDown}
              style={isSmDown ? { marginTop: theme.spacing(1) } : undefined}
            >
              {intl.formatMessage(labels.Label_Download)}
            </GenericButton>
          </Box>
        </Box>
      ))}
    </>
  );
}
